import { render, staticRenderFns } from "./utils-popup-select-character.vue?vue&type=template&id=4c492842&scoped=true"
import script from "./utils-popup-select-character.vue?vue&type=script&lang=js"
export * from "./utils-popup-select-character.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c492842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c492842')) {
      api.createRecord('4c492842', component.options)
    } else {
      api.reload('4c492842', component.options)
    }
    module.hot.accept("./utils-popup-select-character.vue?vue&type=template&id=4c492842&scoped=true", function () {
      api.rerender('4c492842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/popups/utils-popup-select-character.vue"
export default component.exports